var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisplayList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "display_list_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 50.3 50.4",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".display_list_svg__st0{fill:#030104}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "display_list_svg__st0",
    d: "M.8.8h12.3V13H.8zM.8 19.1h12.3v12.2H.8zM.8 37.4h12.3v12.2H.8zM18.2 19.1H49v12.2H18.2zM18.2 37.4H49v12.2H18.2zM18.2.8H49V13H18.2z"
  })));
}
export default SvgDisplayList;